module.exports = __webpack_public_path__ + "assets/img/69592c8ffa8de7c342f2b281fa7b0306.png";